export function addAllObjectsToStore<T>(newObjects: T[], dataFromStore: T[]) {
  const newState = [...dataFromStore, ...newObjects];
  return newState;
}
